import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AccessSettingsService } from '../services';
import { SnackbarService } from '@shared';
import {
  AccessSettingsActionTypes,
  changeStatusMemberFailure,
  changeStatusMemberSuccess,
  getMembersFailure,
  getMembersSuccess,
  getProjects,
  getProjectsFailure,
  getProjectsSuccess,
  inviteMembersFailure,
  inviteMembersSuccess,
  removeMemberFailure,
  removeMemberSuccess,
} from './access-settings.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { IProject } from '../interfaces';

@Injectable()
export class AccessSettingsEffects {
  constructor(
    private _actions$: Actions,
    private _accessSettingsService: AccessSettingsService,
    private _snackbarService: SnackbarService,
  ) {}

  getProjects$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getProjects.type),
      mergeMap(({ isShowMore }) =>
        this._accessSettingsService.getProjects(isShowMore).pipe(
          map(({ count, results: list }) => getProjectsSuccess({ isShowMore, projects: { count, list } })),
          catchError((err) => {
            console.log(err);
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(getProjectsFailure());
          }),
        ),
      ),
    ),
  );

  getMembers$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AccessSettingsActionTypes.GET_MEMBERS),
      mergeMap(({ id }) =>
        this._accessSettingsService.getMembers(id).pipe(
          map((project: IProject) => getMembersSuccess({ project })),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Обновите страницу.');
            return of(getMembersFailure());
          }),
        ),
      ),
    ),
  );

  removeMember$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AccessSettingsActionTypes.REMOVE_MEMBER),
      mergeMap(({ projectId, id, isMember }) =>
        this._accessSettingsService.removeMember(id).pipe(
          map(() => removeMemberSuccess({ projectId, id, isMember })),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Повторите позже.');
            return of(removeMemberFailure());
          }),
        ),
      ),
    ),
  );

  changeStatusMember$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AccessSettingsActionTypes.CHANGE_STATUS_MEMBER),
      mergeMap(({ projectId, id, active }) =>
        this._accessSettingsService.changeStatusMember(id, active).pipe(
          map(() => changeStatusMemberSuccess({ projectId, id, active })),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Повторите позже.');
            return of(changeStatusMemberFailure());
          }),
        ),
      ),
    ),
  );

  inviteMembers$ = createEffect(() =>
    this._actions$.pipe(
      ofType(AccessSettingsActionTypes.INVITE_MEMBERS),
      mergeMap(({ emails, idProject }) => {
        const newEmails: { email: string }[] = (emails as string[]).map((email: string) => ({ email }));
        return this._accessSettingsService.inviteMembers(newEmails, idProject).pipe(
          map(() => inviteMembersSuccess({ countMembers: (emails as string[]).length, idProject })),
          catchError(() => {
            this._snackbarService.openSnackBar('Что-то пошло не так... Повторите позже.');
            return of(inviteMembersFailure());
          }),
        );
      }),
    ),
  );
}
